import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { formatISO } from 'date-fns'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { GapItem, Gap, GapExtended } from '../model/models'

export class GapAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.latestGaps = this.latestGaps.bind(this)
    this.getGaps = this.getGaps.bind(this)
    this.getLatestGap = this.getLatestGap.bind(this)
  }

  public getGaps(contextVariantId: number, startDate: Date, endDate: Date): Promise<GapItem[]> {
    const config = {
      params: {
        start_date: formatISO(startDate),
        end_date: formatISO(endDate),
      },
    } as AxiosRequestConfig
    const endpoint = `/context-variants/${contextVariantId}/gaps`
    return this.get<Gap[]>(endpoint, config)
      .then((response: AxiosResponse<Gap[]>) => {
        const gapItem: GapItem[] = []
        response.data.forEach((gap: Gap) => {
          gapItem.push(new GapItem(gap))
        })
        return [...gapItem].sort((thisGap, otherGap) =>
          thisGap.timeOfImport < otherGap.timeOfImport ? -1 : 1,
        )
      })
      .catch((error) => {
        throw error
      })
  }

  public latestGaps(moduleId: number): Promise<Gap[]> {
    const endpoint = `/modules/${moduleId}/gaps/latest`
    return this.get<Gap[]>(endpoint)
      .then((response: AxiosResponse<Gap[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getLatestGap(contextVariantId: number, date: Date): Promise<GapExtended> {
    const endpoint = `/context-variants/${contextVariantId}/gaps/latest`
    return this.get<GapExtended>(endpoint, {
      params: {
        date_of_execution: date,
      },
    })
      .then((response: AxiosResponse<GapExtended>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const gapAPI = new GapAPI(httpConfig)
